import React, { useState, useEffect } from "react";
import "../styles/header.css";

const Header = ({ navLinks }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activePath, setActivePath] = useState("");

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const closeMenu = (e) => {
      if (menuOpen && !e.target.closest('.menu') && !e.target.closest('.hamburger')) {
        setMenuOpen(false);
      }
    };

    // Add scroll effect
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Check which section is active
    const checkActivePath = () => {
      // Get current hash or pathname
      const currentPath = window.location.hash || window.location.pathname;
      setActivePath(currentPath);
    };

    document.addEventListener('click', closeMenu);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('hashchange', checkActivePath);
    
    // Set initial active path
    checkActivePath();

    return () => {
    document.removeEventListener('click', closeMenu);
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('hashchange', checkActivePath);
    };
  }, [menuOpen]);

  // Function to check if link is active
  const isActive = (href) => {
    if (href.startsWith('#')) {
      return activePath === href;
    }
    return activePath === href;
  };

  return (
  <header className={scrolled ? "scrolled" : ""}>
    <nav>
    <div className="logo">
      <img src="/assets/Logo White.svg" alt="INBI Logo" />
    </div>
      <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✕" : "☰"}
      </div>
    <ul className="nav-links">
        {navLinks.map((link, index) => (
          <li key={index}>
            {link.to ? (
            <a 
            href={link.to} 
            className={isActive(link.to) ? "active-link" : ""}
            >
            {link.label}
            </a>
            ) : (
            <a 
            href={link.href} 
            className={isActive(link.href) ? "active-link" : ""}
            >
            {link.label}
            </a>
            )}
            </li>
          ))}
        </ul>
      </nav>
  <div className={`menu ${menuOpen ? "open" : ""}`}>
        {navLinks.map((link, index) => (
          <div key={index}>
            {link.to ? (
              <a 
                href={link.to} 
                className={isActive(link.to) ? "active-link" : ""}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ) : (
              <a 
                href={link.href} 
                className={isActive(link.href) ? "active-link" : ""}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            )}
          </div>
        ))}
      </div>
    </header>
  );
};export default Header;